import React, { Component, Fragment } from 'react';
import { PATHS, DETAIL_ACTIONS } from "../../../../../constants/Define";
import * as HMS from "../../../common/component/Index";
import * as Func from '../../../../../helpers/functions';
import { isEqual, cloneDeep } from 'lodash';
import Wrapper from './../../../common/component/Wrapper';
import Input from "../../../common/component/Input";
import { checkUndefine } from "../../../../../helpers/functions";
import Agent from '../../../../../models/Agent';
import './AgentDetail.less';

const defaultState = {
    action: DETAIL_ACTIONS.CREATE,
    validation: {},
    isGetItem: false
};

class AgentDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            isSubmit: false,
            agent: this.props.agentState.detail.agent,
        }
    }

    componentDidMount() {
        this.initDetail()
    }
    

    initDetail() {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id;
            this.setState({ action: DETAIL_ACTIONS.UPDATE });
            this.props.getAgentDetail(id);
        }
    }

    componentWillUnmount() {
        this.props.setAgentDetail(new Agent())
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.agentState.detail.agent && !isEqual(nextProps.agentState.detail.agent, this.props.agentState.detail.agent)) {
            this.setState({ agent: nextProps.agentState.detail.agent, action: nextProps.agentState.detail.agent.id ? 'UPDATE' : this.state.action });
        }
    }

    inputForm = (t, fieldName, required = false) => (
        <HMS.FormWrapperInputComponent
            isRequired={required}
            isValidation={required}
            dataValidation={this.state.agent[fieldName]}
            validation={this.state.validation[fieldName]}
            labelTitle={t(`item.agent.${fieldName}`)}
        >
            <Input placeholder="" type={`text`}
                className={`form-control`}
                name={fieldName} onChange={(e) => this.onChange(fieldName, e.target.value)}
                value={Func.checkUndefine(this.state.agent[fieldName])} />
        </HMS.FormWrapperInputComponent>
    )

    render() {
        const { t } =  this.props;
        const { action, isSubmit, isGetItem } = this.state;

        return (
            <Fragment>
                <HMS.LoadingComponent spinning={isSubmit}>
                    <HMS.PageListComponent className="agent-detail-page">
                        <HMS.HeaderListComponent
                            path={this.props.match.path}
                            groupPath={'agents'}
                            titleHeader={
                                action === "CREATE" ?
                                    Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.agent.title')}`).toLowerCase())
                                    : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.agent.title')}`.toLowerCase()))
                            }
                        />
                        <HMS.FormActionComponent
                            onSubmit={this.onSubmit}
                            isSubmit={isSubmit}
                            action={action}
                            isGetItem={isGetItem}
                            onClickBack={this.onClickBack}
                            onChangeActive={e => this.onChangeDetail(e.name, e.value)}
                            submitButtonRight={true}
                            statusActiveName={`isActive`}
                        >
                            <Wrapper className='col-md-12 basic-section'>
                                
                                <HMS.FormWrapperItem>
                                    <Wrapper className="col-md-6">
                                        <h6 className="title-header">
                                            Thông tin đại lý
                                        </h6>
                                        {this.inputForm(t, 'name', true)}
                                        {this.inputForm(t, 'email', true)}
                                        <div className="row">
                                            <Wrapper className="col-md-6">
                                                {this.inputForm(t, 'phoneNumber', true)}
                                            </Wrapper>
                                            <Wrapper className="col-md-6">
                                                {this.inputForm(t, 'taxNumber')}
                                            </Wrapper>
                                        </div>
                                        {this.inputForm(t, 'address')}
                                    </Wrapper>
                                    <Wrapper className="col-md-6">
                                        <h6 className="title-header">
                                            Thông tin liên lạc
                                        </h6>
                                        <div className="row">
                                            <Wrapper className="col-md-12">
                                                {this.inputForm(t, 'contactFullname')}
                                            </Wrapper>
                                            <Wrapper className="col-md-6">
                                                {this.inputForm(t, 'contactEmail')}
                                            </Wrapper>
                                            <Wrapper className="col-md-6">
                                                {this.inputForm(t, 'contactPhoneNumber')}
                                            </Wrapper>
                                        </div>
                                    </Wrapper>
                                </HMS.FormWrapperItem>
                            </Wrapper>
                        </HMS.FormActionComponent>
                    </HMS.PageListComponent>
                </HMS.LoadingComponent>
            </Fragment>
        )
    }

    onChange = (fieldName, value) => {
        const agent = this.state.agent;
        const keyString = fieldName === 'key' ? this.convertStringKey(value) : value;
        agent[fieldName] = keyString.trimLeft();
        this.setState({ agent });
    };

    onSubmit = (e) => {
        e.preventDefault();
        const { agent, action } = this.state;
        if (this.validate()) {
            if (action === DETAIL_ACTIONS.CREATE) {
                this.props.createAgentDetail(agent)
            } else {
                this.props.updateAgentDetail({ agent, props: this.props })
            }
        }
    }

    validate() {
        const { t } = this.props;
        let validate = {
            minLength: { phoneNumber: t('validation.minPhone'), password: t('validation.minpassword') },
            maxLength: { phoneNumber: t('validation.maxPhone') },
            isNumber: {
                taxNumber: t('validation.statusCode.code.2')
            },
            isPhone: { 
                phoneNumber: t('validation.isPhone'),
                contactPhoneNumber: t('validation.isPhone')
            },
            isEmail: { 
                email: t('validation.email'),
                contactEmail: t('validation.email')
            },
            required: {
                name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.agent.name`)),
                email: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.agent.email`)),
                phoneNumber: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.agent.phoneNumber`)),
            }
        };
        let valueValidate = {};
        const result = Func.multipleValidate(this.state.agent, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    onClickBack = () => {
        this.props.history.push(PATHS.AGENT.LIST.path);
    }
}

export default AgentDetail;
